import AppConstants from '../config/app.constants';

let OrderPackingService = function ($http, $q) {

    let orderPackingList = (branchId, locationId) => {
        return $http
            .post(AppConstants.api + `/order-packing/order-packing-list`, {
                branchId,
                locationId
            })
            .then((res) => {
                return res.data
            })
    }

    let packableOrderPack = (branchFundingSourceId, orderNo, supervisorId, routeId, routeSeq, labels, deliveryToShipmentTypes, vaultDate, labelSeparator = null) => {
        return $http
            .post(AppConstants.api + `/order-packing/packable-order-pack`, {
                branchFundingSourceId,
                orderNo,
                supervisorId,
                routeId,
                routeSeq,
                labels,
                deliveryToShipmentTypes,
                vaultDate,
                labelSeparator
            })
            .then((res) => {
                return res.data
            })
    }

    let orderPackingPack = (fundingSourceId, shipmentId, trackingIdDelivery, trackingIdResidual, routeId, toLocationId, 
                            amount, denominationId, account, branchId, orderNo, supervisorId, vaultDate, deliveryDate, deliveryToShipTypes,
                            singleDenomShipments) => {
        return $http
            .post(AppConstants.api + `/order-packing/order-packing-pack`, {
                fundingSourceId,
                shipmentId,
                trackingIdDelivery,
                trackingIdResidual,
                routeId,
                toLocationId,
                amount, 
                denominationId, 
                account,
                branchId,
                orderNo,
                supervisorId,
                vaultDate, 
                deliveryDate,
                // TODO: LIMIT THE PAYLOAD
                deliveryToShipTypes,
                singleDenomShipments
            })
            .then((res) => {
                return res.data
            })
    }

    let getOrderCassetteUsage = (orderNo, toLocationId) => {
        return $http
            .post(AppConstants.api + `/order-packing/order-cassette-usage`, {
                orderNo,
                toLocationId
            })
            .then((res) => {
                return res.data
            })
    }

    let verifyTrackingIds = (trackingIds, packableOrderId) => {
        return $http.post(AppConstants.api + '/order-packing/verify-tracking-ids', {
            trackingIds
        });
    }

    let orderPackingCancel = (shipmentId, branchId) => {
        return $http
            .post(AppConstants.api + `/order-packing/order-packing-cancel`, {
                shipmentId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let orderPackingCompleteList = (branchId, vaultDate) => {
        return $http
            .post(AppConstants.api + `/order-packing/order-packing-complete-list`, {
                branchId,
                vaultDate
            })
            .then((res) => {
                return res.data
            })
    }

    let getcurBalanceByDenom = (branchId, account, denomination, fundingSourceId) => {
        return $http
            .post(AppConstants.api + `/order-packing/get-current-balance`, {
                branchId,
                account,
                denomination,
                fundingSourceId
            })
            .then((res) => {
                return res.data
            })
    }

    let softDelete = (trackingId, branchId, reason, supervisorId) => {
        return $http
            .post(AppConstants.api + `/order-packing/soft-delete`, {
                trackingId,
                branchId,
                reason,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    };

    let softDeleteOrder = (orderNo, supervisorId, branchId) => {
        return $http
            .post(AppConstants.api + `/order-packing/soft-delete-order`, {
                orderNo,
                supervisorId,
                branchId
            })
            .then((res) => {
                return res.data
            })
    };

    let getLastOrderInformation = (locationId, date) => {
        return $http
            .post(AppConstants.api + `/order-packing/last-order-info`, {
                locationId, 
                date
            })
            .then((res) => {
                return res.data
            })
    };

    let getPendingPackShipmentsOnHold = (branchId, date) => {
        return $http
            .get(AppConstants.api + `/order-packing/get-pending-pack-shipments-on-hold`, {
                params: {
                    branchId,
                    date
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getPackedShipments = (branchId, vaultDate, offset, limit, bfsId) => {
        const params = {
            branchId,
            vaultDate,
            offset,
            limit
        };
        
        // Add bfsId if provided for currency filtering
        if (bfsId) {
            params.bfsId = bfsId;
        }
        
        return $http
            .get(AppConstants.api + `/order-packing/get-packed-shipments`, { params })
            .then((res) => {
                return res.data
            })
    };

    let getPackedOrders = (branchId, locationId) => {
        return $http
            .post(AppConstants.api + `/order-packing/get-packed-orders`, {
                branchId,
                locationId,
            })
            .then((res) => {
                return res.data;
            });
    };

    let exportPackedShipments = (branchId, date, sortColumn, sortASC, orderType, route, searchText, bfsId, currencySymbol, customerId) => {
        return new Promise(function (resolve, reject) {
            var url = AppConstants.api + `/order-packing/export-packed-shipments`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                branchId, 
                date,
                sortColumn, 
                sortASC,
                orderType,
                route,
                searchText,
                bfsId,
                currencySymbol: currencySymbol || '$',
                customerId
            }

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var dt = moment(date).format('DDMMYY');
                    sheetName = reportPrefix.concat(' Packed_Shipment_', dt, '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        });
    }

    let exportPendingPackShipmentsAndOrders = (fundingSourceId, fundingSource, branchId, orderType, route, searchText, date, currencySymbol, filterDate, customerId) => {
        return new Promise(function (resolve, reject) {
            var url = AppConstants.api + `/order-packing/export-pending-pack-shipments-and-orders`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            var data = {
                fundingSourceId,
                fundingSource,
                branchId,
                orderType,
                route,
                searchText,
                date,
                currencySymbol: currencySymbol || '$',
                filterDate,
                customerId
            }

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');
                    var reportPrefix = branchId;
                    var dt = moment(date).format('DDMMYY');
                    sheetName = reportPrefix.concat(' Pending_Pack_Shipment_', dt, '.xlsx');
                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                }
                else reject();
            };

            return xhr.send(JSON.stringify(data));
        });
    }

    let getOrderPackRoutes = (branchId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/order-packing/get-order-pack-routes`, {
                params: {
                    branchId,
                    vaultDate
                }
            })
            .then((res) => {
                return res.data
            })
    }

    const printPackedShipments = (branchId, date, sortColumn, sortASC, orderType, route, searchText, bfsId, currencySymbol, customerId) => {
        return $http
            .post(AppConstants.api + `/order-packing/print-packed-shipments`, {
                branchId,
                date,
                sortColumn,
                sortASC,
                orderType,
                route,
                searchText,
                bfsId,
                currencySymbol: currencySymbol || '$',
                customerId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        orderPackingList,
        orderPackingPack,
        getOrderCassetteUsage,
        orderPackingCancel,
        orderPackingCompleteList,
        getcurBalanceByDenom,
        packableOrderPack,
        softDelete,
        softDeleteOrder,
        getLastOrderInformation,
        getPendingPackShipmentsOnHold,
        getPackedShipments,
        getPackedOrders,
        exportPackedShipments,
        exportPendingPackShipmentsAndOrders,
        getOrderPackRoutes,
        verifyTrackingIds,
        printPackedShipments
    }
}

OrderPackingService.$inject = ['$http', '$q']

export default OrderPackingService;



// WEBPACK FOOTER //
// ./client/app/services/order-packing.service.js